webpackJsonp([4016850265702045000],{

/***/ "./src/assets/layer.png":
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAARElEQVR42mJiYGBIy4uxSaM3zQjl0B0wTVpyBMygNz3q41Efj/p41MejPh718aiPR3086uNRH4/6eNTHQ8jHgAAAAP//Wb3P854FbfMAAAAASUVORK5CYII="

/***/ }),

/***/ "./src/components/slider.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _templateObject = _taggedTemplateLiteral(['\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    left: 0;\n    overflow:hidden;\n'], ['\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    left: 0;\n    overflow:hidden;\n']),
	    _templateObject2 = _taggedTemplateLiteral(['\n    width: 100%;\n    height: 100%;\n    transform: ', ';\n    transition: all 1s ease-in-out;\n    \n'], ['\n    width: 100%;\n    height: 100%;\n    transform: ', ';\n    transition: all 1s ease-in-out;\n    \n']),
	    _templateObject3 = _taggedTemplateLiteral(['\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    z-index: 3;\n    animation-play-state: paused;\n    object-position: center;\n    transition: all .6s ease;\n'], ['\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    z-index: 3;\n    animation-play-state: paused;\n    object-position: center;\n    transition: all .6s ease;\n']),
	    _templateObject4 = _taggedTemplateLiteral(['\n    width: 100%;\n    height: 100%;\n    position: relative;\n\n    ', '   \n'], ['\n    width: 100%;\n    height: 100%;\n    position: relative;\n\n    ', '   \n']),
	    _templateObject5 = _taggedTemplateLiteral(['\n    position: absolute;\n    right: 60px;\n    bottom: 60px;\n    color: #FFF;\n    font-size: 64px;\n    z-index: 4;\n    font-weight: 100;\n\n    @media screen and (max-width: 468px) {\n        padding: 0 20px;\n        width: 100%;\n        right: initial;\n        font-size: 22px;\n        text-align: right;\n    }\n'], ['\n    position: absolute;\n    right: 60px;\n    bottom: 60px;\n    color: #FFF;\n    font-size: 64px;\n    z-index: 4;\n    font-weight: 100;\n\n    @media screen and (max-width: 468px) {\n        padding: 0 20px;\n        width: 100%;\n        right: initial;\n        font-size: 22px;\n        text-align: right;\n    }\n']),
	    _templateObject6 = _taggedTemplateLiteral(['\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background: url(', ') repeat scroll left top;\n    z-index: 2;\n    opacity: 0.2;\n\n'], ['\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background: url(', ') repeat scroll left top;\n    z-index: 2;\n    opacity: 0.2;\n\n']);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _layer = __webpack_require__("./src/assets/layer.png");
	
	var _layer2 = _interopRequireDefault(_layer);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var Wrapper = _styledComponents2.default.div(_templateObject);
	
	var Scroller = _styledComponents2.default.div(_templateObject2, function (props) {
	    return 'translateY(-' + props.current * 100 + '%)';
	});
	
	var Image = _styledComponents2.default.img(_templateObject3);
	
	var Slide = _styledComponents2.default.div(_templateObject4, function (props) {
	    return props.isCurrent && '\n        .slide-image {\n            @media screen and (max-width: 768px) {\n                animation: position 20s ease;\n                animation-play-state: initial;\n            }\n        }\n    ';
	});
	
	var RightTitle = (0, _styledComponents2.default)(_gatsbyLink2.default)(_templateObject5);
	
	var ImageOverlay = _styledComponents2.default.div(_templateObject6, _layer2.default);
	
	var renderSlide = function renderSlide(index, _ref, current) {
	    var featured_media_url = _ref.featured_media_url,
	        title = _ref.title,
	        slug = _ref.slug;
	    return _react2.default.createElement(
	        Slide,
	        { key: 'slide_' + index + '}', isCurrent: index === current },
	        _react2.default.createElement(ImageOverlay, null),
	        _react2.default.createElement(Image, { src: featured_media_url + '?quality=90&strip=info&w=1600', alt: title, className: 'slide-image' }),
	        _react2.default.createElement(
	            RightTitle,
	            { to: '/post/' + slug },
	            title
	        )
	    );
	};
	
	var Slider = function Slider(_ref2) {
	    var current = _ref2.current,
	        slides = _ref2.slides;
	    return _react2.default.createElement(
	        Wrapper,
	        null,
	        _react2.default.createElement(
	            Scroller,
	            { current: current || 0 },
	            slides && slides.map(function (slide, i) {
	                return renderSlide(i, slide.node, current);
	            })
	        )
	    );
	};
	
	exports.default = Slider;
	module.exports = exports['default'];

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/opt/build/repo/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/opt/build/repo/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/opt/build/repo/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/opt/build/repo/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[\"/opt/build/repo/node_modules/babel-preset-env/lib/index.js\",\"/opt/build/repo/node_modules/babel-preset-stage-0/lib/index.js\",\"/opt/build/repo/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./src/pages/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.pageQuery = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _templateObject = _taggedTemplateLiteral(['\n  position: absolute;\n  z-index: 4;\n  left: 50px;\n  bottom: 20px;\n  opacity: 0.8;\n\n  @media screen and (max-width: 468px) {\n    position: absolute;\n    left: 0;\n    padding: 0 20px;\n    text-align: center;\n  }\n'], ['\n  position: absolute;\n  z-index: 4;\n  left: 50px;\n  bottom: 20px;\n  opacity: 0.8;\n\n  @media screen and (max-width: 468px) {\n    position: absolute;\n    left: 0;\n    padding: 0 20px;\n    text-align: center;\n  }\n']);
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__("./node_modules/styled-components/lib/index.js");
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _header = __webpack_require__("./src/components/header.js");
	
	var _header2 = _interopRequireDefault(_header);
	
	var _footer = __webpack_require__("./src/components/footer.js");
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _slider = __webpack_require__("./src/components/slider.js");
	
	var _slider2 = _interopRequireDefault(_slider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
	
	var HomeFooter = (0, _styledComponents2.default)(_footer2.default)(_templateObject);
	
	var IndexPage = function (_React$Component) {
	  _inherits(IndexPage, _React$Component);
	
	  function IndexPage() {
	    _classCallCheck(this, IndexPage);
	
	    var _this = _possibleConstructorReturn(this, (IndexPage.__proto__ || Object.getPrototypeOf(IndexPage)).call(this));
	
	    _this.SLIDER_INTERVAL = 8000;
	
	    _this.state = {
	      currentSlide: 0
	    };
	    return _this;
	  }
	
	  _createClass(IndexPage, [{
	    key: 'slide',
	    value: function slide() {
	      var currentSlide = this.state.currentSlide;
	      var nextSlide = currentSlide < 2 ? currentSlide + 1 : 0;
	
	      this.setState({
	        currentSlide: nextSlide
	      });
	    }
	  }, {
	    key: 'initSlider',
	    value: function initSlider() {
	      var _this2 = this;
	
	      this.interval = setInterval(function () {
	        return _this2.slide();
	      }, this.SLIDER_INTERVAL);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.initSlider();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearInterval(this.interval);
	    }
	  }, {
	    key: 'renderSlider',
	    value: function renderSlider(categories, slides) {
	      return _react2.default.createElement(_slider2.default, { slides: slides, current: this.state.currentSlide });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var categories = this.props.data.allWordpressCategory;
	      var pages = this.props.data.allWordpressPage;
	      var slides = this.props.data.allWordpressPost.edges;
	
	      var slider = this.renderSlider(categories, slides);
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_header2.default, { pages: pages, categories: categories, currentPage: this.props.location.pathname }),
	        slider,
	        _react2.default.createElement(HomeFooter, null)
	      );
	    }
	  }]);
	
	  return IndexPage;
	}(_react2.default.Component);
	
	exports.default = IndexPage;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// page-component---src-pages-index-js-0ce92424a0a513363a26.js